import { render, staticRenderFns } from "./BrowserMask.vue?vue&type=template&id=4f9f1d35&scoped=true"
import script from "./BrowserMask.vue?vue&type=script&lang=js"
export * from "./BrowserMask.vue?vue&type=script&lang=js"
import style0 from "./BrowserMask.vue?vue&type=style&index=0&id=4f9f1d35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9f1d35",
  null
  
)

export default component.exports